import { useState } from 'react';
import { RouterProvider } from 'react-router';
import { CustomNotifications } from '@/kit/CustomNotifications';
import { DialogHost } from '@/kit/dialog';
import { Providers } from './providers';
import { createAppRouter } from './router';

export function App() {
  // Created once, on first render.
  const [router] = useState(createAppRouter);

  return (
    <Providers>
      <CustomNotifications />
      <DialogHost />
      <RouterProvider router={router} />
    </Providers>
  );
}
